import React from "react";
import { LegalLayout, Section } from "@/pages/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Termos de Uso">
      <p className="text-slate-400">Última atualização: 2026.</p>

      <Section heading="1. Sobre o Pronto.AI">
        <p>
          O Pronto.AI é uma ferramenta de apoio que ajuda o usuário a transformar uma necessidade
          em uma instrução (prompt) organizada para usar em ferramentas de inteligência artificial
          de terceiros, como ChatGPT, Gemini ou Claude. O Pronto.AI não é um curso.
        </p>
      </Section>

      <Section heading="2. Uso da ferramenta">
        <p>
          Ao utilizar o Pronto.AI, você concorda em usá-lo de forma lícita e responsável. Você é
          responsável pelo conteúdo que informa nos formulários e pelo uso que faz das instruções
          geradas.
        </p>
      </Section>

      <Section heading="3. Resultados">
        <p>
          As instruções geradas servem como ponto de partida. Os resultados finais podem variar
          conforme a ferramenta de IA utilizada. O Pronto.AI não garante resultados específicos.
        </p>
      </Section>

      <Section heading="4. Pagamento">
        <p>
          O acesso é oferecido por meio de um pagamento único de R$ 4,99. Não há assinatura nem
          cobrança recorrente por parte da ferramenta. As condições de compra, entrega do acesso,
          cancelamento e reembolso seguem a política da plataforma de pagamento utilizada no
          checkout e a legislação aplicável.
        </p>
      </Section>

      <Section heading="5. Propriedade e marcas de terceiros">
        <p>
          O Pronto.AI não possui afiliação com OpenAI, Anthropic, Google ou outras empresas
          citadas. As marcas mencionadas pertencem aos seus respectivos titulares.
        </p>
      </Section>

      <Section heading="6. Alterações">
        <p>
          Estes termos podem ser atualizados. Recomendamos revisá-los periodicamente.
        </p>
      </Section>
    </LegalLayout>
  );
}
